'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fass';
var iconName = 'rotate-right';
var width = 512;
var height = 512;
var aliases = ["redo-alt","rotate-forward"];
var unicode = 'f2f9';
var svgPathData = 'M512 192l0-200-79 79c-100.3-96-259.4-94.7-358 4-50.2 50.2-75.2 116.1-75 181.9 0 2 0 3.9 .1 5.9 .9 35.4 9 68.9 22.9 99.3 12.4 27.2 29.7 52.6 52 74.9l0 0c46.3 46.3 110.3 75 181 75 100.1 0 186.8-57.5 228.8-141.1l-57.2-28.8c-31.6 62.8-96.6 105.8-171.6 105.8-84.3 0-156-54.4-181.8-130-6.1-17.9-9.5-36.6-10.1-55.3-.1-2.2-.1-4.5-.1-6.8l0 0c0-49.2 18.7-98.3 56.2-135.8 73.6-73.6 192.2-75 267.5-3.9L312 192 512 192z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faRotateRight = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;